import Box from "@mui/material/Box";
import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { AbstractPageContent } from "../sections/AbstractPageContent";
import { MatchDetailsProvider } from "./matchDetails/MatchDetailsContext";

interface AbstractPageProps {
  navLinks: { href: string; label: string }[];
  legalLinks: { href: string; label: string }[];
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  disableContainer?: boolean;
}

const AbstractPage: React.FC<AbstractPageProps> = ({
  navLinks,
  legalLinks,
  children,
}) => {
  return (
    <MatchDetailsProvider>
      <Box
        sx={{
          minHeight: "100vh",
          background: (theme) => theme.palette.background.default,
        }}
      >
        <Navbar navLinks={navLinks} />

        <AbstractPageContent>{children}</AbstractPageContent>
        <Footer navLinks={navLinks} legalLinks={legalLinks} />
      </Box>
    </MatchDetailsProvider>
  );
};

export default AbstractPage;
